export const SET_SELECTED_COMPANY = 'SET_SELECTED_COMPANY';
export const SET_MODAL_VIEW = 'SET_MODAL_VIEW'